import { Box, useTheme, alpha } from '@mui/material'
import { memo, useMemo } from 'react'
import { green, red } from '../../../../assets/colors'

type OptionChainOiChangeBarProps = {
    change: number
    maxOiChange: number
    side: string
}

/** OI change magnitude bar (green/red), width ∝ |change| / chain max change. */
const OptionChainOiChangeBar = ({ change, maxOiChange, side }: OptionChainOiChangeBarProps) => {
    const theme = useTheme()
    const trackTint = alpha(theme.palette.divider, theme.palette.mode === 'dark' ? 0.85 : 0.9)

    const widthPct = useMemo(() => {
        if (!change || maxOiChange <= 0) return 0
        return Math.min(100, (Math.abs(change) / maxOiChange) * 100)
    }, [change, maxOiChange])

    if (widthPct <= 0) {
        return null
    }

    const barColor = change > 0 ? green : red
    const mirrored = side === 'left'

    return (
        <Box
            className="option-chain-oi-change-track"
            sx={{
                backgroundColor: trackTint,
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
            }}
        >
            {mirrored ? <Box sx={{ flex: 1, minWidth: 0 }} /> : null}
            <Box
                sx={{
                    width: `${widthPct}%`,
                    height: '100%',
                    minWidth: '2px',
                    flexShrink: 0,
                    backgroundColor: barColor,
                    borderRadius: mirrored ? '0 2px 2px 0' : '2px 0 0 2px',
                }}
            />
        </Box>
    )
}

export default memo(OptionChainOiChangeBar)
